import _ from 'lodash';
import { BASE_TOOL_COMMON_PROPS } from '@/toolSelection/baseTool.constants';
import { BaseToolStore } from '@/toolSelection/baseTool.store';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import type { BaseToolPersistedState } from '@/toolSelection/baseTool.store';
import type { ItemOutputV1 } from '@seeqdev/api/model/ItemOutputV1';

interface DisplayToolState extends BaseToolPersistedState {
  asset: ItemOutputV1 | undefined;
  isScaled: boolean;
}

export type DisplayToolDehydratedState = DisplayToolState;

export class DisplayToolStore extends BaseToolStore {
  static readonly storeName = 'sqDisplayToolStore';
  type = TREND_TOOLS.DISPLAY;

  initialize(): void {
    const initialState: DisplayToolState = {
      ...BASE_TOOL_COMMON_PROPS,
      asset: undefined,
      isScaled: true,
    };
    this.state = this.immutable(initialState);
  }

  get asset(): ItemOutputV1 | undefined {
    return this.state.get('asset');
  }

  get isScaled(): boolean {
    return this.state.get('isScaled');
  }

  dehydrate(): DisplayToolDehydratedState {
    return this.state.serialize();
  }

  rehydrate(dehydratedState: Partial<DisplayToolDehydratedState>): void {
    this.state.merge(dehydratedState);
  }

  setAsset(payload: { asset: ItemOutputV1 | undefined }): void {
    this.state.set('asset', payload.asset);
  }

  setIsScaled(payload: { isScaled: boolean }): void {
    this.state.set('isScaled', payload.isScaled);
  }

  localHandlers = {
    DISPLAY_TOOL_ASSET: this.setAsset,
    DISPLAY_TOOL_IS_SCALED: this.setIsScaled,
  };

  handlers = _.assign({}, super.baseHandlers, this.localHandlers);
}
